import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { useDesignVersionPath } from '@/hooks'

import { NAVIGATION_LABELS } from '../../../helpers/constants'
import NavigationLabel from '../../NavigationLabel/NavigationLabel'

const SocialLink = ({ withUpsellingRedirect }) => {
  const { t } = useTranslation(['navbar'])

  const socialLinksPath = useDesignVersionPath('social-links', {
    legacy: '/dashboard/building-dashboard/social-links/legacy',
    new: '/dashboard/building-dashboard/social-links',
  })

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to={withUpsellingRedirect ? '/dashboard/upselling/reputationManagement' : socialLinksPath}
      >
        <span>
          {t('navbar:upsellingLinks.social')}
          <NavigationLabel
            type={NAVIGATION_LABELS.HIDDEN}
            locked={Boolean(withUpsellingRedirect)}
          />
        </span>
      </NavLink>
    </div>
  )
}

SocialLink.propTypes = {
  withUpsellingRedirect: PropTypes.bool,
}

export default SocialLink
